import { styled } from "@mui/system";
const Video = styled("video")(() => ({
  width: "100%",
  border: "none",
  maxWidth: "350px"
}));

export default Video;
